<template>
  <v-container fluid fill-height self-align="center" class="ma-0 pa-0">
    <v-card flat class="box-container ma-0 pa-0" style="width: 100%">
      <v-card-title class="row-header">
        <v-row justify="center" align="center" class="pb-2">
          <v-divider></v-divider>
          <span class="mx-4" :class="isOnMobile ? 'subtitle-2' : 'subtitle-1'">Добавяне на ново плащане за Tremol Assistant</span>
          <v-divider></v-divider>
        </v-row>
      </v-card-title>
      <v-card-actions v-if="!error_message" class="row-header ma-0 ma-1 pa-0">
        <v-form class="ma-0 pa-0" ref="refValidationForm" lazy-validation>
          <v-row class="ma-0 pa-0">
            <v-combobox class="ma-2 pa-2" no-data-text="Не е намерен клиент" v-model="clientEik" allow-overflow :items="clients" :return-object="false" label="ЕИК клиент" item-text="eik" item-value="eik" style="max-width: 150px"></v-combobox>
            <!-- <v-text-field class="ma-2 pa-2" :rules="[...global_rules.required, ...global_rules.validEIK]" style="max-width: 150px" maxlength="10" label="ЕИК на клиента" v-model="clientEik" dense></v-text-field> -->
            <v-text-field class="ma-2 pa-2 centered-input" :rules="[...global_rules.money]" style="max-width: 100px" maxlength="10" label="Сума" type="number" v-model.number="amount"></v-text-field>
            <t-button :class="'ma-2 pa-2'" :btnIcon="'mdi-sticker-plus-outline'" btnText="Добавяне на плащане" :btnColor="'success'" @click.native="createPayReq()" />
          </v-row>
        </v-form>
      </v-card-actions>
      <v-card-title class="row-header">
        <v-row justify="center" align="center" class="pb-2">
          <v-divider></v-divider>
          <span class="mx-4" :class="isOnMobile ? 'subtitle-2' : 'subtitle-1'">Извършени плащания и консумирани бонуси</span>
          <v-divider></v-divider>
        </v-row>
      </v-card-title>
      <v-card-text class="ma-0 pa-0 row-content-limited">
        <v-row justify="center" class="ma-0 pa-2">
          <v-data-table class="elevation-0" :mobile-breakpoint="0" :dense="isOnMobile ? true : userSettings.denseGrid" item-key="my_custom_id" hide-default-footer :items="payments" :headers="dataheaders" fluid fixed-header disable-pagination style="width: 100%; max-width: 800">
            <template v-slot:no-data>
              <v-row align="center" justify="center" class="ma-0 pa-0">
                <v-alert :value="true" color="default" icon="mdi-emoticon-sad">{{ error_message != null ? error_message : "Няма данни за показване" }}</v-alert>
              </v-row>
            </template>
            <template v-for="(h, index) in dataheaders" v-slot:[`item.${h.value}`]="{ item }">
              <template v-if="h.value == 'invFileName' && Object.byString(item, h.value)">
                <div :key="index" class="data-grid-cell" style="cursor: pointer; justify-content: center" @click="openInvoice(item[h.value])">
                  <v-icon class="pr-2" small>mdi-file-pdf</v-icon>
                  <span style="text-decoration: underline">
                    {{ formatCell(h.proptype, Object.byString(item, h.value)).replace("Invoice_", "").replace(".pdf", "") }}
                  </span>
                </div>
              </template>
              <template v-else-if="h.value == 'bonus'">
                <span :key="index" class="data-grid-cell" :class="item.bonus > 0 ? 'success--text' : 'error--text'" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'">
                  {{ formatCell(h.proptype, item.bonus) }}
                </span>
              </template>
              <template v-else>
                <span :key="index" class="data-grid-cell" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'">
                  {{ formatCell(h.proptype, Object.byString(item, h.value)) }}
                </span>
              </template>
            </template>
            <template v-slot:[`header.bonus`]="{ header }">
              <div>
                <span style="white-space: pre-wrap">
                  {{ header.text + ": " }}
                  <span :class="userBalance ? (userBalance < 0 ? 'error--text' : 'success--text') : ''">{{ userBalance ? formatCell(DataPropType.Money, userBalance) : "" }}</span>
                </span>
              </div>
            </template>

            <!-- <template class="ma-0 pa-0" v-slot:expanded-item="{ headers, item }">
              <td></td>
              <td :colspan="headers.length - 1" class="ma-0 pa-0">
                <v-data-table :dense="isOnMobile ? true : userSettings.denseGrid" class="ma-0 pa-0 elevation-0" disable-pagination :headers="dataheadersexpanded" :items="item.details" item-key="my_custom_id" hide-default-footer hide-default-header>
                  <template v-for="(hh, indexx) in dataheadersexpanded" v-slot:[`item.${hh.value}`]="{ item }">
                    <span :key="indexx" class="data-grid-cell" :style="hh.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + hh.cell_align + ';'">
                      {{ formatCell(hh.proptype, Object.byString(item, hh.value)) }}
                    </span>
                  </template>
                </v-data-table>
              </td>
            </template> -->
          </v-data-table>

          <!-- <v-data-table ref="refGrid" locale="bg-BG" :mobile-breakpoint="0" item-key="my_custom_id" class="ma-0 pa-0 elevation-0 customscroll" :height="getGridHeight" :show-expand="datatype !== null && datatype.expandedProp !== undefined" :expanded.sync="expanded" :dense="isOnMobile ? true : userSettings.denseGrid" fluid fixed-header multi-sort hide-default-footer :page.sync="page" :headers="getHeaders" :items="getData" :loading="isLoading" loading-text="Данните се обработват, моля изчакайте..." :items-per-page="itemsPerPage" @page-count="pageCount = $event" @current-items="currentItems = $event" @pagination="paginationObj = $event" @update:page="page = $event">
            <template v-slot:no-data>
              <v-row align="center" justify="center">
                <v-alert :value="true" max-width="400px" color="default" icon="mdi-emoticon-sad">Няма данни за показване</v-alert>
              </v-row>
            </template>
            <template v-for="(h, index) in dataheaders" v-slot:[`item.${h.value}`]="{ item }">
              <span :key="index" class="data-grid-cell" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';' + (hasCellClickEvent(h.value) ? ' cursor: pointer; text-decoration: underline;' : '')" @contextmenu.stop="showContextMenu($event, item)" @click="getCellClickEvent($event, item, h.value)">
                {{ formatCell(h.proptype, Object.byString(item, h.value)) }}
              </span>
            </template>
            <template v-if="datatype && datatype.expandedProp" v-slot:expanded-item="{ headers, item }">
              <td colspan="2" class="ma-0 pa-0"></td>
              <td :colspan="headers.length - 2" class="ma-0 pa-0">
                <v-data-table :dense="isOnMobile ? true : userSettings.denseGrid" class="ma-0 pa-0 elevation-0" :headers="dataheadersexpanded" :items="item[datatype.expandedProp]" hide-default-footer />
              </td>
            </template>
          </v-data-table> -->
        </v-row>
      </v-card-text>

      <!-- <v-card-text v-if="!error_message" class="row-header ma-0 pa-0">
        <v-row justify="center" class="ma-0 pa-0">
          <v-simple-table class="elevation-0" :dense="isOnMobile ? true : userSettings.denseGrid" style="width: 100%; max-width: 550px">
            <tbody>
              <tr style="height: #px">
                <td style="height: 2px" colspan="3" class="ma-0 pa-0"></td>
              </tr>
              <tr>
                <td width="40%" class="text-left">
                  <span>Текущ баланс:</span>
                </td>
                <td width="35%" class="text-center">
                  <span>{{ new Date().toTremolFpString() }}</span>
                </td>
                <td width="25%" class="text-right">
                  <span :class="userBalance < 0 ? 'error--text' : 'success--text'">{{ formatCell(DataPropType.Money, userBalance) }}</span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-row>
      </v-card-text> -->
    </v-card>
  </v-container>
</template>

<script>
import DataManager, { DataHeader, DataPropType, ErrorMessage } from "../../js/DataManager";
import { TR } from "../../main";
//import bus from "../../main";

export default {
  data() {
    return {
      amount: 0,
      user: null,
      clientEik: "",
      distribEik: null,
      clients: [],
      DataPropType: DataPropType,
      payments: [],
      error_message: null,
      dataheaders: [
        new DataHeader("Дата", "dateRequested", DataPropType.Date, "center"),
        new DataHeader("Клиент ЕИК", "forCuser.eik", DataPropType.String, "center"),
        new DataHeader("Сума", "amount", DataPropType.Money, "end"),
        new DataHeader("Бонус", "bonus", DataPropType.Money, "end", false, true),
        new DataHeader("Фактура номер", "invFileName", DataPropType.String),
        new DataHeader("Фактура дата", "dateMarkedPayed", DataPropType.DateShort, "center"),
      ],
      datatype: null,
    };
  },
  computed: {
    userBalance() {
      if (!this.user) return 0;
      return this.user.distrPmtBonusAccumulated ? this.user.distrPmtBonusAccumulated : 0;
    },
  },
  methods: {
    setTitleAndData(meta, error) {
      this.user = DataManager.getData(DataManager.DataType.user);
      this.datatype = meta.datatype;
      this.distribEik = DataManager.getData(DataManager.DataType.user).eik;
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.refreshData();
        DataManager.loadData(DataManager.DataType.distrib_users, (err) => {
          if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            this.clients = DataManager.getData(DataManager.DataType.distrib_users, true);
          }
        });
      } else {
        this.error_message = error.Message;
        this.dialogLoader.showError(error.Message, { location: "center" });
      }
    },
    refreshData() {
      const paymentz = DataManager.getData(this.datatype, true);
      this.payments = paymentz.map((item, index) => ({
        my_custom_id: index,
        ...item,
      }));
      this.payments.forEach(p=>{ 
        if(p.externalBalanceBonus || p.bonusDiscInvoive) {
          p.bonus = -p.amount;
          p.amount = undefined;
        } else {
          p.bonus = (p.amount * 0.15).roundTo(2);
        }
      })
      //console.log(this.payments);
      this.payments.sortByDesc("dateRequested");
    },
    formatCell(proptype, value) {
      return DataManager.formatGridData(proptype, value);
    },
    createPayReq() {
      if (this.$refs.refValidationForm.validate()) {
        setTimeout(() => {
          this.$nextTick(() => {
            if (this.amount < 5) {
              this.dialogLoader.showError("Минималната сума за внасяне е 5", { location: "center" });
              return;
            } else {
              this.dialog.show(
                "yes-no",
                null,
                {
                  title: "Внимание",
                  buttonYesText: "Да",
                  buttonNoText: "Не",
                  text: "Сигурни ли сте, че искате да добавите " + this.amount + " " + TR.MoneyAbbreviation + " към акаунта на клиент с ЕИК " + this.clientEik + "?\nЗаявката е необратима и подлежи на фактуриране.",
                },
                (result) => {
                  if (result) {
                    DataManager.createDistribPayRequest(this.distribEik, this.clientEik, this.amount, (err) => {
                      if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
                        this.amount = 0;
                        this.clientEik = "";
                        this.$refs.refValidationForm.reset();
                        DataManager.loadData(
                          this.datatype,
                          (errLp) => {
                            if (errLp.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
                              this.dialogLoader.showInfo("Заявката за абонамент е подадена успешно!");
                              this.refreshData();
                            } else {
                              this.dialogLoader.showError("Грешка! " + errLp.Message, { timeout: 5000, location: "center" });
                            }
                          },
                          true,
                        );
                      } else {
                        this.dialogLoader.showError("Грешка! " + err.Message, { timeout: 5000, location: "center" });
                      }
                    });
                  }
                },
              );
            }
          });
        }, 500);
      }
    },
  },
  watch: {},
  mounted() {
    // bus.$on(bus.EVENT_DataManager_DATA_CHANGED, (datatype) => {
    //   if (datatype == this.datatype) {
    //     this.refreshData();
    //   }
    // });
  },
};
</script>
<style scoped>
</style>